import script from "./PagoEnvio.vue?vue&type=script&setup=true&lang=js"
export * from "./PagoEnvio.vue?vue&type=script&setup=true&lang=js"

import "./PagoEnvio.vue?vue&type=style&index=0&id=846682aa&scoped=true&lang=css"

import exportComponent from "/var/www/html/manual/expositores/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-846682aa"]])

export default __exports__